import Loader from 'components/Loader';
import { getCities, getCountries, getRegions, getSubAreas } from 'containers/school/actions';
import { citiesSelector, countriesSelector, regionsSelector, subAreasSelector } from 'containers/school/selectors';
import { useFormik } from 'formik';
import { useRouter } from 'hooks/useRouter';
import isEmpty from 'lodash/isEmpty';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import Select from 'react-select';
import Creatable from 'react-select/creatable';
import { toast } from 'react-toastify';
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Row,
} from 'reactstrap';
import { createStructuredSelector } from 'reselect';
import { SMKLinks } from 'utils/links';
import * as Yup from 'yup';
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import useRequest from '../../../hooks/useRequest';
import { LATITUDE_REGEX, LONGITUDE_REGEX, PHONE_REGEX } from 'utils/constants';
import { checkIfValueExist, printPhoneNumber } from 'utils/helper';
import { HEATLHCARE_HEADERS } from 'containers/healthcare/helpers';

const stateSelector = createStructuredSelector({
  countries: countriesSelector,
  regions: regionsSelector,
  cities: citiesSelector,
  subAreas: subAreasSelector,
});

const UpdateHealthCareFacility = () => {
  const { id: facilityId } = useParams();

  const router = useRouter();
  const history = useHistory();
  const dispatch = useDispatch();
  const { countries, regions, cities, subAreas } = useSelector(stateSelector);
  toast.configure();

  const [facilityDetails, setfacilitysDetails] = useState({});

  const [getFacilityRequest, { loading: getFacilityLoading }] = useRequest({
    ...HEATLHCARE_HEADERS,
    url: `/healthcare/healthcare-facility/admin/${facilityId}`,
    method: 'GET',
    onSuccess: (data) => {
      setfacilitysDetails(data);
    },
    onError: (err) => {
      toast.error(err?.message);
      console.log(err);
    },
  });

  const [addFacilityRequest, { loading: addFacilityLoading }] = useRequest({
    ...HEATLHCARE_HEADERS,
    url: `/healthcare/healthcare-facility/admin`,
    method: 'POST',
    onSuccess: () => {
      history.replace(SMKLinks.HEALTH_CARE_LISTING);
      toast.success('Success! Health care facility has been Added');
    },
    onError: (err) => {
      toast.error(err?.message);
    },
  });

  const [updateFacilityRequest, { loading: updateFacilityLoading }] = useRequest({
    ...HEATLHCARE_HEADERS,
    url: `/healthcare/healthcare-facility/admin/${facilityId}`,
    method: 'PUT',
    onSuccess: () => {
      window.location.reload();
      toast.success('Success! Health care facility has been updated.');
    },
    onError: (err) => {
      toast.error(err?.message);
      console.log(err);
    },
  });

  const editInitialValues = () => {
    const country = !isEmpty(facilityDetails?.address?.country)
      ? {
          label: facilityDetails?.address?.country,
          value: facilityDetails?.address?.country,
          name: facilityDetails?.address?.country,
        }
      : null;
    const region = !isEmpty(facilityDetails?.address?.region)
      ? {
          label: facilityDetails?.address?.region,
          value: facilityDetails?.address?.region,
          name: facilityDetails?.address?.region,
        }
      : null;
    const city = !isEmpty(facilityDetails?.address?.city)
      ? {
          label: facilityDetails?.address?.city,
          value: facilityDetails?.address?.city,
          name: facilityDetails?.address?.city,
        }
      : null;
    const subArea = !isEmpty(facilityDetails?.address?.subArea)
      ? {
          label: facilityDetails?.address?.subArea,
          value: facilityDetails?.address?.subArea,
          name: facilityDetails?.address?.subArea,
        }
      : null;

    if (!isEmpty(country)) {
      dispatch(
        getRegions.trigger({
          level: 1,
          country: country.name,
          page: 1,
          size: 500,
          sortBy: 'slug',
          sortOrder: 0,
        })
      );
    }
    if (!isEmpty(region)) {
      dispatch(
        getCities.trigger({
          level: 3,
          cityOnly: true,
          region: region.name,
          page: 1,
          size: 500,
          sortBy: 'slug',
          sortOrder: 0,
        })
      );
    }

    if (!isEmpty(city)) {
      dispatch(getSubAreas.trigger({ level: 4, city: city.name, page: 1, size: 500, sortBy: 'slug', sortOrder: 0 }));
    }

    return {
      id: facilityDetails?.id,
      active: facilityDetails?.active,
      deleted: facilityDetails?.deleted,
      name: facilityDetails?.name,
      email: facilityDetails?.email ? facilityDetails?.email : '',
      phoneNumber: facilityDetails?.phoneNumber ? facilityDetails?.phoneNumber : '',
      notes: facilityDetails?.notes,

      line1: facilityDetails?.address?.line1,
      line2: facilityDetails?.address?.line2,
      landmark: facilityDetails?.address?.landmark,
      postalCode: facilityDetails?.address?.postalCode,

      country,
      region,
      city,
      subArea,

      latitude: facilityDetails?.address?.location?.latitude,
      longitude: facilityDetails?.address?.location?.longitude,
    };
  };

  const getInitialValues = () => ({
    active: true,
    deleted: false,
    name: '',
    email: '',
    phoneNumber: '',
    notes: '',

    country: null,
    region: null,
    city: null,
    subArea: null,
    line1: '',
    line2: '',
    landmark: '',
    postalCode: '',
    latitude: '',
    longitude: '',
  });

  const formik = useFormik({
    enableReinitialize: true,
    validateOnChange: true,
    validateOnBlur: false,
    initialValues: getInitialValues(),
    onSubmit: async (values) => {
      const payload = {
        active: values?.active,
        deleted: values?.deleted,
        name: values?.name,
        email: values?.email,
        phoneNumber: values?.phoneNumber,
        notes: values?.notes,
        address: {
          line1: checkIfValueExist(values?.line1),
          line2: checkIfValueExist(values?.line2),
          country: !isEmpty(values?.country?.slug) ? values?.country?.slug : '',
          region: !isEmpty(values?.region?.slug) ? values?.region?.slug : '',
          city: !isEmpty(values?.city?.slug) ? values?.city?.slug : '',
          subArea: !isEmpty(values?.subArea?.slug) ? values?.subArea?.slug : '',
          landmark: checkIfValueExist(values?.landmark),
          postalCode: checkIfValueExist(values?.postalCode),
          location: {
            latitude: +values?.latitude,
            longitude: +values?.longitude,
          },
        },
      };

      isEmpty(facilityId)
        ? addFacilityRequest({
            body: payload,
          })
        : updateFacilityRequest({
            body: payload,
          });
    },
    validationSchema: Yup.object().shape({
      name: Yup.string()
        .required('Please provide name')
        .min(3, 'Title should be at least 3 characters long')
        .max(50, 'Title should be at most 50 characters long'),
      email: Yup.string()
        .email()
        .required('Please provide email'),
      phoneNumber: Yup.string()
        .required('Please provide phone number')
        .matches(PHONE_REGEX, 'Please enter correct format'),

      line1: Yup.string().required('Please provide Line 1'),
      postalCode: Yup.string().required('Please provide postal code'),
      country: Yup.object()
        .nullable(true)
        .test('countryTest', 'Please select country', (val) => !isEmpty(val)),
      region: Yup.object()
        .nullable(true)
        .test('regionTest', 'Please select region/state', (val) => !isEmpty(val)),
      city: Yup.object()
        .nullable(true)
        .test('cityTest', 'Please select city', (val) => !isEmpty(val)),
      latitude: Yup.string()
        .required('Please provide latitude')
        .matches(LATITUDE_REGEX, 'Please enter correct format'),
      longitude: Yup.string()
        .required('Please provide longitude')
        .matches(LONGITUDE_REGEX, 'Please enter correct format'),
    }),
  });

  useEffect(() => {
    if (!isEmpty(facilityId)) {
      getFacilityRequest();
    }
  }, [facilityId]);

  useEffect(() => {
    dispatch(getCountries.trigger({ level: 0, page: 1, size: 500, sortBy: 'slug', sortOrder: 0 }));
  }, []);

  useEffect(() => {
    if (!isEmpty(facilityDetails)) {
      const updatedValues = editInitialValues();
      formik.setValues(updatedValues);
    }
  }, [facilityDetails]);

  const onCountrySelect = (country) => {
    if (!isEmpty(country)) {
      dispatch(
        getRegions.trigger({
          level: 1,
          country: country.name,
          page: 1,
          size: 500,
          sortBy: 'slug',
          sortOrder: 0,
        })
      );
      formik.setFieldValue('country', country);
      formik.setFieldValue('city', null);
      formik.setFieldValue('subArea', null);
    }
  };

  const onRegionSelect = (region) => {
    if (!isEmpty(region)) {
      dispatch(
        getCities.trigger({
          level: 3,
          cityOnly: true,
          region: region.name,
          page: 1,
          size: 500,
          sortBy: 'slug',
          sortOrder: 0,
        })
      );
      formik.setFieldValue('region', region);
      formik.setFieldValue('city', null);
      formik.setFieldValue('subArea', null);
    }
  };

  const onCitySelect = (city) => {
    if (!isEmpty(city)) {
      dispatch(getSubAreas.trigger({ level: 4, city: city.name, page: 1, size: 500, sortBy: 'slug', sortOrder: 0 }));

      formik.setFieldValue('city', city);
      formik.setFieldValue('subArea', null);
    }
  };

  const onSubAreaSelect = (subArea) => {
    if (!isEmpty(subArea)) {
      if (!subArea.id && !subArea.name) {
        subArea.name = subArea.label;
      }

      formik.setFieldValue('subArea', subArea);
    }
  };

  return (
    <>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Loader isActive={addFacilityLoading || getFacilityLoading || updateFacilityLoading} />
          <Breadcrumbs
            title="Health care facility"
            breadcrumbItem={`${isEmpty(facilityId) ? 'Add' : 'Edit'} Health care facility`}
          />
          <Form onSubmit={formik.handleSubmit}>
            <Row>
              <Col md={9}>
                <Card>
                  <CardBody>
                    <Row>
                      <Col md={12}>
                        <FormGroup className="mb-4">
                          <Label for="name" className="form-label  ">
                            Name
                          </Label>
                          <Input
                            id="name"
                            type="text"
                            className="form-control"
                            placeholder="Name..."
                            invalid={!!(formik.touched.name && formik.errors.name)}
                            {...formik.getFieldProps('name')}
                            error={!isEmpty(formik.errors.name)}
                          />
                          <FormFeedback>{formik.errors.name}</FormFeedback>
                        </FormGroup>
                      </Col>

                      <Col md={6}>
                        <FormGroup className="mb-4">
                          <Label for="email" className="form-label  ">
                            Email
                          </Label>
                          <Input
                            id="email"
                            type="text"
                            className="form-control"
                            placeholder="Email..."
                            invalid={!!(formik.touched.email && formik.errors.email)}
                            {...formik.getFieldProps('email')}
                          />
                          <FormFeedback>{formik.errors.email}</FormFeedback>
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup className="mb-4">
                          <Label for="phoneNumber" className="form-label  ">
                            Phone Number
                          </Label>
                          <Input
                            id="phoneNumber"
                            type="number"
                            className="form-control"
                            placeholder="Phone Number..."
                            invalid={!!(formik.touched.phoneNumber && formik.errors.phoneNumber)}
                            {...formik.getFieldProps('phoneNumber')}
                          />
                          <FormFeedback>{formik.errors.phoneNumber}</FormFeedback>
                        </FormGroup>
                      </Col>

                      <Col md={12}>
                        <FormGroup className="mb-4">
                          <Label for="schooldesc" className="form-label  ">
                            Notes
                          </Label>
                          <Input
                            type="textarea"
                            className="form-control"
                            id="schooldesc"
                            rows="8"
                            placeholder="Notes..."
                            invalid={!!(formik.touched.notes && formik.errors.notes)}
                            {...formik.getFieldProps('notes')}
                          />
                          <FormFeedback>{formik.errors.notes}</FormFeedback>
                        </FormGroup>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>

                <Card>
                  <CardBody>
                    <h5 className="mb-4 pb-3 border-bottom">Address</h5>
                    <Row>
                      <Col md={6}>
                        <FormGroup className="mb-4">
                          <Label for="country" className="form-label">
                            Country
                          </Label>
                          <Select
                            id="country"
                            options={countries}
                            value={formik.values.country}
                            placeholder="Please select a country"
                            onChange={onCountrySelect}
                          />
                          {formik.touched.country && (
                            <div className="invalid-feedback d-block">{formik.errors.country}</div>
                          )}
                        </FormGroup>
                      </Col>

                      <Col md={6}>
                        <FormGroup className="mb-4">
                          <Label for="region" className="form-label  ">
                            Region
                          </Label>
                          <Creatable
                            id="region"
                            placeholder="Select region..."
                            value={formik.values.region}
                            onChange={onRegionSelect}
                            options={regions}
                          />
                          {formik.touched.city && (
                            <div className="invalid-feedback d-block">{formik.errors.region}</div>
                          )}
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup className="mb-4">
                          <Label for="city" className="form-label  ">
                            City
                          </Label>
                          <Creatable
                            id="city"
                            placeholder="Select city..."
                            value={formik.values.city}
                            onChange={onCitySelect}
                            options={cities}
                          />
                          {formik.touched.city && <div className="invalid-feedback d-block">{formik.errors.city}</div>}
                        </FormGroup>
                      </Col>

                      <Col md={6}>
                        <FormGroup className="mb-4">
                          <Label for="subArea" className="form-label  ">
                            SubArea
                          </Label>
                          <Select
                            id="subArea"
                            placeholder="Select subarea..."
                            value={formik.values.subArea}
                            onChange={onSubAreaSelect}
                            options={subAreas}
                          />
                          {formik.touched.subArea && (
                            <div className="invalid-feedback d-block">{formik.errors.subArea}</div>
                          )}
                        </FormGroup>
                      </Col>

                      <Col md={6}>
                        <FormGroup className="mb-4">
                          <Label for="line1" className="form-label  ">
                            Line 1
                          </Label>
                          <Input
                            id="line1"
                            type="text"
                            className="form-control"
                            placeholder="Line 1..."
                            invalid={!!(formik.touched.line1 && formik.errors.line1)}
                            {...formik.getFieldProps('line1')}
                          />
                          <FormFeedback>{formik.errors.line1}</FormFeedback>
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup className="mb-4">
                          <Label for="line2" className="form-label  ">
                            Line 2
                          </Label>
                          <Input
                            id="line2"
                            type="text"
                            className="form-control"
                            placeholder="Line 2..."
                            invalid={!!(formik.touched.line2 && formik.errors.line2)}
                            {...formik.getFieldProps('line2')}
                          />
                          <FormFeedback>{formik.errors.line2}</FormFeedback>
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup className="mb-4">
                          <Label for="landmark" className="form-label  ">
                            Landmark
                          </Label>
                          <Input
                            id="landmark"
                            type="text"
                            className="form-control"
                            placeholder="Landmark..."
                            invalid={!!(formik.touched.landmark && formik.errors.landmark)}
                            {...formik.getFieldProps('landmark')}
                          />
                          <FormFeedback>{formik.errors.landmark}</FormFeedback>
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup className="mb-4">
                          <Label for="postalCode" className="form-label  ">
                            Postal code
                          </Label>
                          <Input
                            id="postalCode"
                            type="number"
                            className="form-control"
                            placeholder="Postal code..."
                            invalid={!!(formik.touched.postalCode && formik.errors.postalCode)}
                            {...formik.getFieldProps('postalCode')}
                          />
                          <FormFeedback>{formik.errors.postalCode}</FormFeedback>
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup className="mb-4">
                          <Label htmlFor="latitude" className="form-label  ">
                            Latitude
                          </Label>
                          <Input
                            id="latitude"
                            type="text"
                            className="form-control mb-1"
                            placeholder="Latitude..."
                            invalid={!!(formik.touched.latitude && formik.errors.latitude)}
                            {...formik.getFieldProps('latitude')}
                          />
                          Ref: 20.12345678
                          <FormFeedback className="d-block">{formik.errors.latitude}</FormFeedback>
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup className="mb-4">
                          <Label htmlFor="longitude" className="form-label  ">
                            Longitude
                          </Label>
                          <Input
                            id="longitude"
                            type="text"
                            className="form-control mb-1"
                            placeholder="Longitude..."
                            invalid={!!(formik.touched.longitude && formik.errors.longitude)}
                            {...formik.getFieldProps('longitude')}
                          />
                          Ref: 20.12345678
                          <FormFeedback className="d-block">{formik.errors.longitude}</FormFeedback>
                        </FormGroup>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>

              <Col md={3}>
                <Card>
                  <CardBody>
                    <Button type="submit" color="primary" className="w-100 mb-3">
                      {`${isEmpty(facilityId) ? 'Add' : 'Update'}`} Health care facility
                    </Button>

                    <Button
                      className="w-100"
                      color="light"
                      onClick={() => {
                        history.replace(SMKLinks.HEALTH_CARE_LISTING);
                      }}>
                      Cancel
                    </Button>
                  </CardBody>
                </Card>

                <Card>
                  <CardBody>
                    <div>
                      <CardTitle className="mb-3">Active</CardTitle>
                      {[true, false].map((option, i) => (
                        <div key={`active_${i}`} className="form-check mb-3 d-inline-block me-4">
                          <input
                            type="radio"
                            id={`active_${option}`}
                            name="active"
                            className="form-check-input"
                            checked={formik.values.active === option}
                            onChange={() => formik.setFieldValue('active', option)}
                          />
                          <label className="form-check-label" htmlFor={`active_${option}`}>
                            {option ? 'Yes' : 'No'}
                          </label>
                        </div>
                      ))}
                    </div>
                    <div>
                      <CardTitle className="mb-3">Delete </CardTitle>
                      {[true, false].map((option, i) => (
                        <div key={`deleted_${i}`} className="form-check mb-3 d-inline-block me-4">
                          <input
                            type="radio"
                            id={`deleted_${option}`}
                            name="deleted"
                            className="form-check-input"
                            checked={formik.values.deleted === option}
                            onChange={() => formik.setFieldValue('deleted', option)}
                          />
                          <label className="form-check-label" htmlFor={`deleted_${option}`}>
                            {option ? 'Yes' : 'No'}
                          </label>
                        </div>
                      ))}
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Form>
        </Container>
      </div>
    </>
  );
};

export default UpdateHealthCareFacility;
